import { MainFormSkeleton } from 'components/common-form/components/mainFormSkeleton';
import { SidePanel } from 'components/common-form/sidePanel';
import { FormAnalyticsProvider } from 'components/form-analytic-provider';
import { FormTabGuard } from 'components/form-tab-guard';
import { ProductAndClientSelector } from 'components/shared/ProductAndClientSelector/ProductAndClientSelector';
import { SidePanelContainer } from 'components/staticForm/sidePanelLayout/SidePanelContainer';
import { ConnectedStaticForm } from 'components/staticForm/StaticForm';
import { useAppSelector } from 'hooks/useAppSelector';
import { useIsInternalUser } from 'hooks/useIsInternalUser';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { FormIdProps } from 'shared/props';
import { staticWorkspaceTabProductSelectionSubmittedThunk } from 'state/workspaces/static/static.thunks';
export function StaticMain({ formId }: FormIdProps) {
  const dispatch = useThunkDispatch();
  const activeTabContent = useAppSelector(state => state.workspaces.static[formId]);
  const canSelectClient = useIsInternalUser();

  if (activeTabContent?.isFetchingTabContent) {
    return (
      <FormAnalyticsProvider name="advanced form">
        <SidePanelContainer sidePanel={<SidePanel tabId={formId} workspaceType="static" />}>
          <MainFormSkeleton />
        </SidePanelContainer>
      </FormAnalyticsProvider>
    );
  }

  if (!activeTabContent?.isProductValidated) {
    return (
      <ProductAndClientSelector
        workspace="static"
        canSelectClient={canSelectClient}
        onSubmitted={({ productType, productSubType, wrapper, requestType }, client) =>
          dispatch(
            staticWorkspaceTabProductSelectionSubmittedThunk(
              formId,
              productType,
              productSubType,
              wrapper,
              requestType,
              client,
            ),
          )
        }
      />
    );
  }

  return (
    <FormTabGuard formId={formId}>
      <ConnectedStaticForm formId={formId} />
    </FormTabGuard>
  );
}
